var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpColoured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Question_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13.1111 18.6667C13.1111 19.2803 12.6137 19.7778 12 19.7778C11.3864 19.7778 10.8889 19.2803 10.8889 18.6667C10.8889 18.053 11.3864 17.5556 12 17.5556C12.6137 17.5556 13.1111 18.053 13.1111 18.6667ZM12 4.33333C9.60676 4.33333 7.66667 6.27343 7.66667 8.66667H9.66667C9.66667 7.378 10.7113 6.33333 12 6.33333H12.1048C13.3356 6.33333 14.3333 7.33109 14.3333 8.56188V9.13207C14.3333 9.75079 13.9374 10.3001 13.3504 10.4958C11.9468 10.9636 11 12.2772 11 13.7568V16.4444H13V13.7568C13 13.1381 13.3959 12.5888 13.9829 12.3931C15.3866 11.9252 16.3333 10.6117 16.3333 9.13207V8.56188C16.3333 6.22652 14.4401 4.33333 12.1048 4.33333H12Z",
    fill: "#008AED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpColoured);
export default __webpack_public_path__ + "static/media/Help_Coloured.c2b7f4e9e3d5a63926e0197d80d9cb15.svg";
export { ForwardRef as ReactComponent };